import React from 'react';
import { SortableHandle } from 'react-sortable-hoc';
import SortIcon from '../../../icons/sort.svg'

import './DragHandle.scss';

const DragHandle = () => <SortIcon styleName="handle" />;

export default SortableHandle(DragHandle);